import { createSelector } from "@ngrx/store";
import { AppState } from "src/app/core/models/app-state.models";

export const selectTitlebar = createSelector(
    (state: AppState) => state.titlebar,
    titlebar => titlebar
);
